import {Injectable} from '@angular/core';

import {Subject} from 'rxjs';

import {Alert} from '../classes';
import {AlertTypesEnum} from '../enums';

@Injectable({
    providedIn: 'root'
})
export class AlertsService {
    private readonly alertsCollection: Alert[];

    public alertsEmitter: Subject<Alert[]>;

    constructor() {
        this.alertsCollection = [];
        this.alertsEmitter = new Subject();
    }

    private removeCollectionItem(index: number): void {
        this.alertsCollection.splice(index, 1);

        /**
         * Arrange indexes after removing of the current one.
         */
        this.alertsCollection.map((alert: Alert, position: number) => alert.index = position);

        this.alertsEmitter.next(this.alertsCollection);
    }

    /**
     * Add alert to the internal collection and return its index.
     * Remove alert from the collection automatically after 'AlertTimeOut' interval.
     * Return the index of currently added message.
     */
    addAlert(message: string, type: AlertTypesEnum = AlertTypesEnum.Error, autoRemovable: boolean = true): number {
        const filteredAlerts = this.alertsCollection.filter((item: Alert) => {
            return (item.message === message) && (item.type === type);
        });

        if (filteredAlerts.length !== 0) {
            return null;
        }

        const index = this.alertsCollection.length;
        const alert = new Alert(index, type, message, autoRemovable);

        this.alertsCollection.push(alert);

        this.alertsEmitter.next(this.alertsCollection);

        return index;
    }

    removeAlert(index: number): void {
        if (typeof this.alertsCollection[index] !== 'undefined') {
            if (this.alertsCollection[index].subscription) {
                this.alertsCollection[index].subscription.unsubscribe();
            }

            this.removeCollectionItem(index);
        }
    }

    removeAllAlerts(): void {
        this.alertsCollection.map((alert: Alert) => alert.subscription && alert.subscription.unsubscribe());
        this.alertsCollection.splice(0, this.alertsCollection.length);
        this.alertsEmitter.next([]);
    }
}
